const H = {
  name: "Amsterdam",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 0H8V4H5V8H2V24H4V10H7V6H10V2H14V6H17V10H20V24H22V8H19V4H16V0Z" fill="currentColor"/>
<path d="M18 12H6V24H18V12ZM8 14H11V17H8V14ZM8 19H11V22H8V19ZM13 19H16V22H13V19ZM16 17H13V14H16V17Z" fill="currentColor"/>
</svg>
  `
};
export {
  H as Amsterdam
};
